import before_1 from "./img/BeforeYouStart/mbys_ris_ass.png";
import before_2 from "./img/BeforeYouStart/mbys_ind.png";
import before_3 from "./img/BeforeYouStart/mbys_sig.png";
import before_4 from "./img/BeforeYouStart/mbys_sup.png";
import before_5 from "./img/BeforeYouStart/mbys_cle.png";
import before_6 from "./img/BeforeYouStart/mbys_con_saf.png";
import before_7 from "./img/BeforeYouStart/mbys_fev.png";
import before_8 from "./img/BeforeYouStart/mbys_cou.png";
import before_9 from "./img/BeforeYouStart/mbys_sho_of_bre.png";
import before_10 from "./img/BeforeYouStart/mbys_los_of_sme.png";
import before_11 from "./img/BeforeYouStart/mbys_sel_iso.png";
import before_12 from "./img/BeforeYouStart/mbys_cov_19_tes.png";

import veh_1 from "./img/Vehicles/covi_par.png";
import veh_2 from "./img/Vehicles/covi_sig_occ.png";
import veh_3 from "./img/Vehicles/covi_ven.png";
import veh_4 from "./img/Vehicles/covi_enh_cle.png";
import veh_5 from "./img/Vehicles/covi_han_san.png";

import wo_1 from "./img/WorkOrganisation/covi_dis_act.png";
import wo_2 from "./img/WorkOrganisation/covi_wor_met.png";
import wo_3 from "./img/WorkOrganisation/covi_org_tea.png";
import wo_4 from "./img/WorkOrganisation/covi_org_bre.png";
import wo_5 from "./img/WorkOrganisation/covi_org_sta_spa.png";
import wo_6 from "./img/WorkOrganisation/covi_org_rou.png";
import wo_7 from "./img/WorkOrganisation/covi_min_pub_enc.png";
import wo_8 from "./img/WorkOrganisation/covi_use_sta.png";

import rso_1 from "./img/RoadSurfacingOperations/covi_str.png"
import rso_2 from "./img/RoadSurfacingOperations/covi_dre.png"

import wa_1 from "./img/WelfareArrangements/covi_wel_cle_mat.png"
import wa_2 from "./img/WelfareArrangements/covi_wel_enh_cle.png"
import wa_3 from "./img/WelfareArrangements/covi_wel_sta_shi.png"
import wa_4 from "./img/WelfareArrangements/covi_wel_cap.png"
import wa_5 from "./img/WelfareArrangements/covi_wel_was_col.png"
import wa_6 from "./img/WelfareArrangements/covi_wel_que_man.png"
import wa_7 from "./img/WelfareArrangements/covi_wel_was.png"

import ca_1 from "./img/CanteenArrangements/covi_can_cle_mat.png"
import ca_2 from "./img/CanteenArrangements/covi_can_sta_num.png"
import ca_3 from "./img/CanteenArrangements/covi_can_sea.png"
import ca_4 from "./img/CanteenArrangements/covi_can_sta.png"
import ca_5 from "./img/CanteenArrangements/covi_can_was_han.png"
import ca_6 from "./img/CanteenArrangements/covi_can_que_man.png"
import ca_7 from "./img/CanteenArrangements/covi_can_cle.png"
import ca_8 from "./img/CanteenArrangements/covi_can_don_sha.png"

import eos_1 from "./img/EatingOnSite/covi_use_you_veh.png"

import pd_1 from "./img/PhysicalDistancing/covi_phy_two_met.png"
import pd_2 from "./img/PhysicalDistancing/covi_phy_no_han.png"
import pd_3 from "./img/PhysicalDistancing/covi_phy_tem_bar.png"
import pd_4 from "./img/PhysicalDistancing/covi_phy_max_dis.png"
import pd_5 from "./img/PhysicalDistancing/covi_phy_15_min.png"
import pd_6 from "./img/PhysicalDistancing/covi_phy_exc_zon.png"
import pd_7 from "./img/PhysicalDistancing/covi_phy_ven.png"

import mee_1 from "./img/Meetings/covi_mee_rem_mee.png"
import mee_2 from "./img/Meetings/covi_mee_red_mee.png"
import mee_3 from "./img/Meetings/covi_mee_red_mee_att.png"

import ph_1 from "./img/PersonalHygiene/covi_per_was_san.png"
import ph_2 from "./img/PersonalHygiene/covi_per_cou_eti.png"
import ph_3 from "./img/PersonalHygiene/covi_per_use_tis.png"
import ph_4 from "./img/PersonalHygiene/covi_per_soa_and.png"
import ph_5 from "./img/PersonalHygiene/covi_per_han_san.png"
import ph_6 from "./img/PersonalHygiene/covi_per_han_wip.png"
import ph_7 from "./img/PersonalHygiene/covi_per_loc_ent.png"
import ph_8 from "./img/PersonalHygiene/covi_per_don_tou.png"

import fir_1 from "./img/FirstAid/covi_aid_fir_aid.png"
import fir_2 from "./img/FirstAid/covi_aid_dis_glo.png"
import fir_3 from "./img/FirstAid/covi_aid_ffp_ffp.png"
import fir_4 from "./img/FirstAid/covi_aid_dis_pla.png"
import fir_5 from "./img/FirstAid/covi_aid_enc_eye.png"

import sig_1 from "./img/Signage/covi_sig_cov_sig.png"
import sig_2 from "./img/Signage/covi_sig_han_was.png"
import sig_3 from "./img/Signage/covi_sig_que_sig.png"
import sig_4 from "./img/Signage/covi_sig_dis_sig.png"
import sig_5 from "./img/Signage/covi_mar_wal_mar.png"

import tes_1 from "./img/ToolsEquipmentSurfaces/covi_too_all_too.png"
import tes_2 from "./img/ToolsEquipmentSurfaces/covi_too_cle_too.png"
import tes_3 from "./img/ToolsEquipmentSurfaces/covi_too_enh_cle.png"
import tes_4 from "./img/ToolsEquipmentSurfaces/covi_too_cle_mat.png"
import tes_5 from "./img/ToolsEquipmentSurfaces/covi_too_cle_fre.png"
import tes_6 from "./img/ToolsEquipmentSurfaces/covi_too_was_col.png"
import tes_7 from "./img/ToolsEquipmentSurfaces/covi_too_min_pap.png"

import del_1 from "./img/Deliveries/covi_del_del_doc.png"
import del_2 from "./img/Deliveries/covi_del_pal_del.png"
import del_3 from "./img/Deliveries/covi_del_phy_dis.png"

import ppe_1 from "./img/PPE/covi_ppe_fac_mas.png"
import ppe_2 from "./img/PPE/covi_ppe_nec_gai.png"
import ppe_3 from "./img/PPE/covi_ppe_ffp_mas.png"
import ppe_4 from "./img/PPE/covi_ppe_dis_glo.png"
import ppe_5 from "./img/PPE/covi_ppe_dis_ove.png"
import ppe_6 from "./img/PPE/covi_ppe_eye_pro.png"
import ppe_7 from "./img/PPE/covi_ppe_fac_shi.png"
import ppe_8 from "./img/PPE/covi_ppe_dis.png"
import ppe_9 from "./img/PPE/covi_ppe_no_hom.png"
import ppe_10 from "./img/PPE/covi_ppe_rad.png"

export default {
    "Before You Start":[
        {
            icon: before_1,
            check: "Risk Assess",
            key: "bef_you_sta_ris_ass"
        },
        {
            icon: before_2,
            check: "Induction",
            key: "bef_you_sta_ind"
        },
        {
            icon: before_3,
            check: "Signatures",
            key: "bef_you_sta_sig"
        },
        {
            icon: before_4,
            check: "Supervision",
            key: "bef_you_sta_sup"
        },
        {
            icon: before_5,
            check: "Cleaning/ Sanitising Materials",
            key: "bef_you_sta_cle"
        },
        {
            icon: before_6,
            check: "Contractor Safety",
            key: "bef_you_sta_con_saf"
        },
        {
            icon: before_7,
            check: "Fever",
            key: "bef_you_sta_fev"
        },
        {
            icon: before_8,
            check: "Cough",
            key: "bef_you_sta_cou"
        },
        {
            icon: before_9,
            check: "Shortness of breath",
            key: "bef_you_sta_sho_of_bre"
        },
        {
            icon: before_10,
            check: "Loss of smell",
            key: "bef_you_sta_los_of_sme"
        },
        {
            icon: before_11,
            check: "Self-isolating",
            key: "bef_you_sta_sel_iso"
        },
        {
            icon: before_12,
            check: "COVID-19 testing",
            key: "bef_you_sta_cov_19_tes"
        }
    ],
    Vehicles: [
        {
            icon: veh_1,
            check: "Parking",
            key: "veh_par"
        },
        {
            icon: veh_2,
            check: "Single occupancy",
            key: "veh_sin_occ"
        },
        {
            icon: veh_3,
            check: "Ventilation",
            key: "veh_ven"
        },
        {
            icon: veh_4,
            check: "Enhanced Cleaning",
            key: "veh_enh_cle"
        },
        {
            icon: veh_5,
            check: "Hand Sanitiser",
            key: "veh_han_san"
        }
    ],
    "Work Organisation": [
        {
            icon: wo_1,
            check: "Disperse Activities",
            key: "wor_org_dis_act"
        },
        {
            icon: wo_2,
            check: "Work Method",
            key: "wor_org_wor_met"
        },
        {
            icon: wo_3,
            check: "Organise teams",
            key: "wor_org_org_tea"
        },
        {
            icon: wo_4,
            check: "Organise breaks",
            key: "wor_orgorg_bre"
        },
        {
            icon: wo_5,
            check: "Organise staff spaces",
            key: "wor_org_org_sta_spa"
        },
        {
            icon: wo_6,
            check: "Organise Routes",
            key: "wor_org_org_rou"
        },
        {
            icon: wo_7,
            check: "Minimise public encounters",
            key: "wor_org_min_pub_enc"
        },
        {
            icon: wo_8,
            check: "Use Stairs",
            key: "wor_org_use_sta"
        }
    ],
    "Road Surfacing Operations": [
        {
            icon: rso_1,
            check: "Strengthening",
            key: "roa_sur_ope_str"
        },
        {
            icon: rso_2,
            check: "Surface Dressing",
            key: "roa_sur_ope_sur_dre"
        }
    ],
    "Welfare Arrangements": [
        {
            icon: wa_1,
            check: "Cleaning Materials",
            key: "wel_ara_cle_mat"
        },
        {
            icon: wa_2,
            check: "Enhanced Cleaning",
            key: "wel_ara_enh_cle"
        },
        {
            icon: wa_3,
            check: "Staggered Shift Times",
            key: "wel_ara_sta_shi_tim"
        },
        {
            icon: wa_4,
            check: "Capacity",
            key: "wel_ara_cap"
        },
        {
            icon: wa_5,
            check: "Waste Collection points",
            key: "wel_ara_sta_was_col_poi"
        },
        {
            icon: wa_6,
            check: "Queue Management",
            key: "wel_ara_que_man"
        },
        {
            icon: wa_7,
            check: "Wash/ Sanitise Hands",
            key: "wel_ara_sta_was_san_han"
        }
    ],
    "Canteen Arrangements": [
        {
            icon: ca_1,
            check: "Cleaning Materials",
            key: "can_ara_cle_mat"
        },
        {
            icon: ca_2,
            check: "Staff numbers",
            key: "can_ara_sta_num"
        },
        {
            icon: ca_3,
            check: "Seating",
            key: "can_ara_sea"
        },
        {
            icon: ca_4,
            check: "Stagger",
            key: "can_ara_sta"
        },
        {
            icon: ca_5,
            check: "Wash/ Sanitise Hands",
            key: "can_ara_was_san_han"
        },
        {
            icon: ca_6,
            check: "Queue Management",
            key: "can_ara_que_man"
        },
        {
            icon: ca_7,
            check: "Clean",
            key: "can_ara_cle"
        },
        {
            icon: ca_8,
            check: "Don't Share",
            key: "can_ara_don_sha"
        }
    ],
    "Eating on Site": [
        {
            icon: eos_1,
            check: "Use Your Vehicle",
            key: "eat_on_sit_use_you_veh"
        }
    ],
    "Physical Distancing": [
        {
            icon: pd_1,
            check: "2 metre space",
            key: "phy_dis_two_met_spa"
        },
        {
            icon: pd_2,
            check: "No hand shaking",
            key: "phy_dis_no_han_sha"
        },
        {
            icon: pd_3,
            check: "Temporary Barriers",
            key: "phy_dis_tem_bar"
        },
        {
            icon: pd_4,
            check: "Maximize distance",
            key: "phy_dis_max_dis"
        },
        {
            icon: pd_5,
            check: "<15 minutes",
            key: "phy_dis_les_tha_15_min"
        },
        {
            icon: pd_6,
            check: "Exclusion Zone",
            key: "phy_dis_exc_zon"
        },
        {
            icon: pd_7,
            check: "Ventilation",
            key: "phy_dis_ven"
        }
    ],
    Meetings: [
        {
            icon: mee_1,
            check: "Remote meetings",
            key: "mee_rem_mee"
        },
        {
            icon: mee_2,
            check: "Reduce meeting time",
            key: "mee_red_mee_tim"
        },
        {
            icon: mee_3,
            check: "Reduce meeting attendance",
            key: "mee_red_mee_att"
        }
    ],
    "Personal Hygiene": [
        {
            icon: ph_1,
            check: "Wash/ Sanitise Hands",
            key: "per_hyg_was_san_han"
        },
        {
            icon: ph_2,
            check: "Cough Etiquette",
            key: "per_hyg_cou_eti"
        },
        {
            icon: ph_3,
            check: "Used Tissue",
            key: "per_hyg_use_tis"
        },
        {
            icon: ph_4,
            check: "Soap and Water",
            key: "per_hyg_soa_and_wat"
        },
        {
            icon: ph_5,
            check: "Hand Sanitiser",
            key: "per_hyg_han_san"
        },
        {
            icon: ph_6,
            check: "Hand Wipes",
            key: "per_hyg_han_wip"
        },
        {
            icon: ph_7,
            check: "Locating at Entrances",
            key: "per_hyg_loc_at_ent"
        },
        {
            icon: ph_8,
            check: "Don't Touch Face",
            key: "per_hyg_don_tou_fac"
        }
    ],
    "First Aid": [
        {
            icon: fir_1,
            check: "First Aider Induction",
            key: "fir_aid_fir_aid_ins"
        },
        {
            icon: fir_2,
            check: "Disposable Gloves (nitrile/latex)",
            key: "fir_aid_dis_glo"
        },
        {
            icon: fir_3,
            check: "FFP3/ FFP2 Face Mask",
            key: "fir_aid_fac_mas"
        },
        {
            icon: fir_4,
            check: "Disposable Plastic Apron",
            key: "fir_aid_dis_pla_apr"
        },
        {
            icon: fir_5,
            check: "Enclosed Eye Protection",
            key: "fir_aid_enc_eye_pro"
        }
    ],
    Signage: [
        {
            icon: sig_1,
            check: "COVID-19 Signage",
            key: "sig_cov_sig"
        },
        {
            icon: sig_2,
            check: "Hand Washing Signage",
            key: "sig_han_was_sig"
        },
        {
            icon: sig_3,
            check: "Queue Signage",
            key: "sig_que_sig"
        },
        {
            icon: sig_4,
            check: "Disinfection Signage",
            key: "sig_dis_sig"
        },
        {
            icon: sig_5,
            check: "Walkway markings",
            key: "sig_wal_mar"
        }
    ],
    "Tools, Equipment, Surfaces":[
        {
            icon: tes_1,
            check: "Allocated Tools",
            key: "too_equ_sur_all_too"
        },
        {
            icon: tes_2,
            check: "Clean Tools",
            key: "too_equ_sur_cle_too"
        },
        {
            icon: tes_3,
            check: "Enhanced Cleaning",
            key: "too_equ_sur_enh_cle"
        },
        {
            icon: tes_4,
            check: "Cleaning Materials",
            key: "too_equ_sur_cle_mat"
        },
        {
            icon: tes_5,
            check: "Cleaning frequency",
            key: "too_equ_sur_cle_fre"
        },
        {
            icon: tes_6,
            check: "Waste Collection points",
            key: "too_equ_sur_was_col_poi"
        },
        {
            icon: tes_7,
            check: "Minimise paperwork",
            key: "too_equ_sur_min_pap"
        }
    ],
    Deliveries: [
        {
            icon: del_1,
            check: "Delivery Dockets",
            key: "del_del_doc"
        },
        {
            icon: del_2,
            check: "Plan Deliveries",
            key: "del_pla_del"
        },
        {
            icon: del_3,
            check: "Physical Distancing",
            key: "del_phy_dis"
        }
    ],
    PPE: [
        {
            icon: ppe_1,
            check: "Face Mask",
            key: "ppe_fac_mas"
        },
        {
            icon: ppe_2,
            check: "Neck Gaiter/Snood",
            key: "ppe_nec_gai_sno"
        },
        {
            icon: ppe_3,
            check: "FFP3/ FFP2 Face Mask",
            key: "ppe_ffp_fac_mas"
        },
        {
            icon: ppe_4,
            check: "Disposable Gloves",
            key: "ppe_dis_glo"
        },
        {
            icon: ppe_5,
            check: "Disposable Overalls",
            key: "ppe_dis_ove"
        },
        {
            icon: ppe_6,
            check: "Eye Protection",
            key: "ppe_eye_pro"
        },
        {
            icon: ppe_7,
            check: "Face Shields",
            key: "ppe_fac_shi"
        },
        {
            icon: ppe_8,
            check: "Disposal",
            key: "ppe_dis"
        },
        {
            icon: ppe_9,
            check: "No Home/ Cleaning",
            key: "ppe_no_hom_cle"
        },
        {
            icon: ppe_10,
            check: "Radios",
            key: "ppe_rad"
        }
    ]
}
